import type { ExpenseCategory, ExpensePaymentMethod } from "@/features/expenses/types";

type Option<T extends string = string> = { value: T; label: string };

export const EXPENSE_CATEGORIES: Option<ExpenseCategory>[] = [
  { value: "salary", label: "Salary / wages" },
  { value: "fuel", label: "Fuel" },
  { value: "lunch", label: "Staff lunch / meals" },
  { value: "client_lunch", label: "Client lunch / entertainment" },
  { value: "travel", label: "Travel" },
  { value: "utilities", label: "Utilities" },
  { value: "maintenance", label: "Maintenance / repairs" },
  { value: "office", label: "Office supplies" },
  { value: "purchase", label: "General purchase" },
  { value: "marketing", label: "Marketing" },
  { value: "rent", label: "Rent" },
  { value: "other", label: "Other" },
];

export const EXPENSE_PAYMENT_METHODS: Option<ExpensePaymentMethod>[] = [
  { value: "cash", label: "Cash" },
  { value: "upi", label: "UPI" },
  { value: "card", label: "Card" },
  { value: "bank_transfer", label: "Bank transfer" },
  { value: "cheque", label: "Cheque" },
  { value: "other", label: "Other" },
];

export function labelFor(options: readonly Option[], value: string | null | undefined) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}
